import { CellGroup, CellItem } from "@/components/cell";
import { SettingContainer } from "@/components/container/setting-container";
import { PageTitleComponent } from "@/components/page-title";
import { APP_VERSION, BUILD_NUMBER } from "@/constants/version";
import { useIsSubscriptionEnabled } from "@/hooks/use-is-subscription-enabled";
import { MembershipModal } from "@/features/user-profile/components/membership-modal";
import { Capacitor } from "@capacitor/core";
import { Purchases, PURCHASES_ERROR_CODE } from "@revenuecat/purchases-capacitor";
import { useEffect, useMemo, useState } from "react";

const SubscriptionCell = () => {
  const { isEnabled: isSubscriptionEnabled } = useIsSubscriptionEnabled();
  const [supportsSubscriptions, setSupportsSubscriptions] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!isSubscriptionEnabled) {
      setSupportsSubscriptions(false);
      return;
    }

    if (typeof window === "undefined") {
      return;
    }

    const platform = Capacitor.getPlatform();
    if (platform !== "ios" && platform !== "android") {
      setSupportsSubscriptions(false);
      return;
    }

    const checkPayments = async () => {
      try {
        const canPay = await Purchases.canMakePayments();
        setSupportsSubscriptions(!!canPay);
      } catch (error: unknown) {
        const code =
          typeof error === "object" && error !== null && "code" in error
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (error as any).code
            : undefined;
        if (
          code === PURCHASES_ERROR_CODE.PURCHASE_NOT_ALLOWED_ERROR ||
          code === PURCHASES_ERROR_CODE.STORE_PROBLEM_ERROR
        ) {
          console.warn("[Subscriptions] Payments not allowed on this device/store", error);
        } else {
          console.warn("[Subscriptions] Failed to check payments support", error);
        }
        setSupportsSubscriptions(false);
      }
    };

    void checkPayments();
  }, [isSubscriptionEnabled]);

  const shouldShowSubscriptionCell = useMemo(() => {
    if (!isSubscriptionEnabled) {
      return false;
    }

    if (typeof window === "undefined") {
      return false;
    }

    const isProduction = window.location.origin === "https://app.nutricoach.co.uk";

    if (!isProduction) {
      return true;
    }

    return supportsSubscriptions;
  }, [isSubscriptionEnabled, supportsSubscriptions]);

  if (!shouldShowSubscriptionCell) {
    return null;
  }

  return (
    <>
      <CellItem label="Subscription" onClick={() => setIsModalOpen(true)} />
      <MembershipModal isOpen={isModalOpen} onDismiss={() => setIsModalOpen(false)} />
    </>
  );
};

export default function MySettingPage() {
  return (
    <SettingContainer className="app-bar-bottom-padding no-scrollbar h-full overflow-y-auto">
      <PageTitleComponent title="Settings" />

      <CellGroup classNames={{ container: "mt-4 flex-1" }}>
        <CellItem label="My Profile" href="/settings/profile" />
        {/* <SettingItem label="Account Setting" href="/my-account" /> */}
        {/* <SettingItem label="My Brands" href="/my-brands" /> */}
        {/* <CellItem label="My Plans" href="/plans/my-plan" /> */}
        <CellItem label="My Preferences" href="/settings/my-preference" />
        <SubscriptionCell />
        <CellItem label="Delete Account" href="/settings/delete-account" />
        {/* <SettingItem label="Help & Support" href="/help-and-support" /> */}
        {/* <SettingItem label="Terms of Service" href="/settings/terms" /> */}
        {/* <SettingItem label="Privacy Policy" href="/settings/privacy" /> */}
        <CellItem label="Version" value={`${APP_VERSION} (${BUILD_NUMBER})`} />
      </CellGroup>
    </SettingContainer>
  );
}
